import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaUsers } from "react-icons/fa";

export default function SendToGroupNode({ data, selected }) {
  const groupCount = Array.isArray(data.groupIds) ? data.groupIds.length : 0;
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[190px] transition-shadow ${
        selected ? "border-emerald-500 shadow-md" : "border-surface-border"
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-emerald-500 !border-2 !border-white"
      />

      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-gradient-to-r from-emerald-600 to-teal-500">
        <FaUsers size={11} className="text-white" />
        <span className="text-xs font-semibold text-white">Group Follow-Up</span>
      </div>

      <div className="px-3 py-2.5 space-y-1.5">
        {data.message ? (
          <p className="text-xs text-ink-muted line-clamp-2">{data.message}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to configure group message</p>
        )}
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-700 text-2xs font-medium">
            {groupCount} group{groupCount === 1 ? "" : "s"}
          </span>
          {Array.isArray(data.groupNames) && data.groupNames.length > 0 && (
            <span className="text-2xs text-ink-faint truncate max-w-[120px]">
              {data.groupNames.slice(0, 2).join(", ")}
            </span>
          )}
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-emerald-500 !border-2 !border-white"
      />
    </div>
  );
}
